import * as types from './types';
import { CLEAR_RECOGNITION } from '../../../app-dux/recognition/types';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    selectedPeople: [],
    searchedPeople: [],
    myTeam: []
};

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case types.SET_SEARCHED_PEOPLE: {
            return {
                ...state,
                searchedPeople: action.people
            };
        }
        case types.SET_MY_TEAM: {
            return {
                ...state,
                myTeam: action.myTeam
            };
        }
        case types.ADD_SELECTED_PERSON: {
            return {
                ...state,
                selectedPeople: [ ...state.selectedPeople, action.person ]
            };
        }
        case types.REMOVE_SELECTED_PERSON: {
            return {
                ...state,
                selectedPeople: state.selectedPeople.filter( person => person.id != action.person.id )
            };
        }
        case types.CLEAR_SEARCHED_PEOPLE: {
            return {
                ...state,
                searchedPeople: []
            };
        }
        case types.ADD_AWARD_TO_PERSON: {
            return {
                ...state,
                selectedPeople: state.selectedPeople.map(
                    ( person, i ) => person.id === action.personId ? { ...person, awardValue: action.awardValue }
                        : person
                )
            };
        }
        case CLEAR_RECOGNITION: {
            return {
                ...state,
                selectedPeople: []
            };
        }
        default:
            return state;
    }
}
